import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export const useReCaptcha = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();

    const verifyReCaptcha = async (action = 'submit') => {
        if (!executeRecaptcha) {
            console.error("Execute recaptcha not yet available");
            return null;  // Returning null if reCAPTCHA is not ready
        }

        const token = await executeRecaptcha(action);
        return token;  // Return the reCAPTCHA token to be used in your form
    };

    return verifyReCaptcha;
};